import { render } from "./articleDetail.vue?vue&type=template&id=0465c18c&scoped=true"
import script from "./articleDetail.vue?vue&type=script&lang=js"
export * from "./articleDetail.vue?vue&type=script&lang=js"

import "./articleDetail.vue?vue&type=style&index=0&id=0465c18c&lang=less&scoped=true"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0465c18c"]])

export default __exports__